import ZShaderMaterial from "../../custom/ZShaderMaterial.js";
import {isMobile} from 'react-device-detect';
import * as THREE from "three";
import {doc} from '../docs.js';

let iteration = 0;

var vertexShader = `
void main() {
  gl_Position = projectionMatrix * modelViewMatrix * vec4(
    position, 
    1.0 );
  
}
`;


doc(
    "gl.material",
    {
        fragColor: "",
        size: "",
    },
    "Outputs a material from the shader expression given in the inlet",
    undefined,
    {
        tags: "GLSL",
        isHot: true,
        inlets: 2,
        connects: {
            object: "three.planeRenderer",
        },
    }
);
export const gl_material = (object, size) => {
    let zshader = new ZShaderMaterial(object);
    object.needsHotReload = true;
    object.shader = zshader;

    object._effect = undefined;
    // send basic vertex shader
    zshader.onVertexShader(vertexShader);

    let lastDiff;
    let _gen = gen(object);

    let counter=0;

    let lastObj = undefined;

    return ([obj]) => {
        if (obj === 'bang') {
            object.sendMessage(object.outputByNumber(0), zshader.material);
            return;
        }
        if (!obj.code) {
            return;
        }
        let _size = size() || [300,300];
        if (!Array.isArray(_size)) {
            _size = [300,300];
        }
        let [_width, _height] = _size;
        obj.uniforms["width"] = {value: _width};
        obj.uniforms["height"] = {value: _height};

        let code = _gen(obj, zshader);

        if (code !== zshader.fragmentShader) {
            if (!object.sequencerEngine.isLoading) {
                let _counter = ++counter;
                setTimeout(() => {
                    if (_counter !== counter) {
                        return;
                    }
                    let d = diff(zshader.fragmentShader, code);
                    console.log("COMPILING uni=%s iteration=%s", Object.keys(obj.uniforms).length, iteration++);
                    window.compiledCode = code;
                    window.compiledUniforms = obj.uniforms;
                    zshader.onFragmentShader(code);
                    lastDiff = d;
                    object.sendMessage(object.outputByNumber(0), zshader.material);
                }, 50);
            }

        }

        // return zshader.material;
    };
};

let updateCount=0;
window.fallBackUpdate = {};
const updateUniforms = (zshader, uniforms, object) => {
    for (let uniform in uniforms) {
        if (uniforms[uniform].update) {
            continue;
        }
        uniforms[uniform].update = (val, dontRender) => {
            if (Array.isArray(val)) {
                // then we need to turn it into a vec2/vec3/mat2/mat3
                if (Array.isArray(val[0])) {
                    // matrix but what typ
                    if (val.length === 3) {
                        // mat3
                        let mat3 = new THREE.Matrix3();
                        mat3.set(... val.flat(6));
                        val = mat3;
                    } 
                } else {
                    if (val.length === 2) {
                        val = new THREE.Vector2(val[0], val[1]);
                    } else if (val.length === 3) {
                        val = new THREE.Vector3(val[0], val[1], val[2]);
                    } else if (val.length === 4) {
                        val = new THREE.Vector4(val[0], val[1], val[2], val[3]);
                    }
                }
            }
            zshader.createUniform(uniform, val);
            if (!window.stopRender && !dontRender) {
                object.sendMessage(object.outputByNumber(0), zshader.material);
            } else {
            }
        };

        let val = uniforms[uniform].value;
        if (Array.isArray(val)) {
            // then we need to turn it into a vec2/vec3/mat2/mat3
            if (Array.isArray(val[0])) {
                // matrix but what typ
                if (val.length === 3) {
                    // mat3
                    let mat3 = new THREE.Matrix3();
                    mat3.set(... val.flat(6));
                    val = mat3;
                }
            } else {
                if (val.length === 2) {
                    val = new THREE.Vector2(val[0], val[1]);
                } else if (val.length === 3) {
                    val = new THREE.Vector3(val[0], val[1], val[2]);
                } else if (val.length === 4) {
                    val = new THREE.Vector4(val[0], val[1], val[2], val[3]);
                }
            }
        }
        window.fallBackUpdate[uniform] = uniforms[uniform].update;
        zshader.createUniform(uniform, val);
    }
}

const gen = (object) => {
    let cachedCode = undefined;
    let cachedShader = undefined;
    return ({code, uniforms, variables, functions}, zshader) => {
        /*
        if (cachedCode === code) {
            updateUniforms(zshader, uniforms, object);
            return cachedShader;
        }
        */
        let shader = `
`;
        
        for (let uniform in uniforms) {
            if (!uniform.includes("$")) {
                let value = uniforms[uniform].value;
                let type = Array.isArray(value) && Array.isArray(value[0]) ? "mat3" : value.length === 4 ? "vec4" : value.length == 3 ? "vec3" : value.length == 2 ? "vec2" : isNaN(uniforms[uniform].value) ? "sampler2D" : "float";
                if (uniform.includes("tex")) {
                    type = "sampler2D";
                }
                shader += "uniform " + type + " " + uniform + "; \n";
            }
        }

        updateUniforms(zshader, uniforms, object);
        
        shader += `

const float EPSILON = 0.0001;
#define PI 3.141592653589793

#define cx_mul(a, b) vec2(a.x*b.x - a.y*b.y, a.x*b.y + a.y*b.x)
#define cx_div(a, b) vec2(((a.x*b.x + a.y*b.y)/(b.x*b.x + b.y*b.y)),((a.y*b.x - a.x*b.y)/(b.x*b.x + b.y*b.y)))
#define cx_sin(a) vec2(sin(a.x) * cosh(a.y), cos(a.x) * sinh(a.y))
#define cx_cos(a) vec2(cos(a.x) * cosh(a.y), -sin(a.x) * sinh(a.y))

// Identity matrix.
const mat3 identity =  mat3(
        vec3(1, 0, 0),
        vec3(0, 1, 0),
        vec3(0, 0, 1)
    );

mat2 rotate2D(float angle) {
    return mat2(
cos(angle), -sin(angle),sin(angle),cos(angle));
}

mat4 lookAt(vec3 eye, vec3 target, vec3 up) {
    vec3 z = normalize(eye - target);
    vec3 x = normalize(cross(up, z));
    vec3 y = normalize(cross(z, x));
    mat4 translation = mat4(
        vec4(1.0, 0.0, 0.0, eye.x),
    	vec4(0.0, 1.0, 0.0, eye.y),
        vec4(0.0, 0.0, 1.0, eye.z),
        vec4(0.0, 0.0, 0.0, 1.0)
    );
    mat4 rotation = ${isMobile ? "translation" : "transpose(mat4(vec4(x, 0.0),vec4(y, 0.0),vec4(z, 0.0),vec4(0.0, 0.0, 0.0, 1.0)))"};
    return translation * rotation;
}

vec3 getRayDir(mat4 camera, float fov) {
    fov = radians(fov);
    vec2 p = 1.0*((gl_FragCoord.xy-vec2(width, height)))/vec2(width, height);
    vec2 h = vec2(
        tan(fov / 2.0) * (width / height), 
        tan(fov / 2.0)
    );
    vec3 pCam = vec3(p * h, -1.0);
    return normalize((${isMobile ? "camera" : "inverse(camera)"} * vec4(pCam, 0.0)).xyz);
}

float sdRoundBoxCoord( vec2 p, vec2 off, vec2 b, float r, mat3 transform, float angle ) 
{
  vec3 p3 = vec3(p, 0.0);
  vec3 off3 = vec3(off, 0.0);
  p3 = (p3 - off3)*transform;
  p.x = p3.x;
  p.y = p3.y;
  p *= rotate2D(angle);
  vec2 q = abs(p)-b+r;
  return min(max(q.x,q.y),0.0) + length(max(q,0.)) - r;
}

float sdRoundBox3DCoord( vec3 p, vec3 off, vec3 b, float r, mat3 transform, float pivot) 
{
  vec3 q = abs(p) - b;
  return length(max(q,0.0)) + min(max(q.x,max(q.y,q.z)),0.0) - r;
}

float sdRoundBox( vec2 off, vec2 b, float r ) 
{
  vec2 p = (1.0*gl_FragCoord.xy-vec2(width, height))/height;
  return sdRoundBoxCoord(p, off, b, r, identity, 0.0);
}

float ATan2(float x, float y)
{
    float angle = asin(x) > 0.0 ? acos(y) : -acos(y);
    return angle;
}

vec3 hsl2rgb(vec3 c) {
    vec3 rgb = clamp(abs(mod(c.x * 6.0 + vec3(0.0,4.0,2.0), 6.0) - 3.0) - 1.0, 0.0, 1.0);
        return c.z + c.y * (rgb - 0.5) * (1.0 - abs(2.0 * c.z - 1.0));
}
vec3 rgb2hsl(vec3 c) {
    float h = 0.0;
    float s = 0.0;
    float l = 0.0;
    float r = c.r;
    float g = c.g;
    float b = c.b;
    float cMin = min( r, min( g, b ) );
    float cMax = max( r, max( g, b ) );
    l = ( cMax + cMin ) / 2.0;
    if ( cMax > cMin ) {
        float cDelta = cMax - cMin;
        s = l < .0 ? cDelta / ( cMax + cMin ) : cDelta / ( 2.0 - ( cMax + cMin ) );
        if ( r == cMax ) {
            h = ( g - b ) / cDelta;
        } else if ( g == cMax ) {
            h = 2.0 + ( b - r ) / cDelta;
        } else {
            h = 4.0 + ( r - g ) / cDelta;
        }
        if ( h < 0.0) {
            h += 6.0;
        }
        h = h / 6.0;
     }
     return vec3( h, s, l );
}

vec4 rainbow(float level)
{
	/*
		Target colors
		=============
		
		L  x   color
		0  0.0 vec4(1.0, 0.0, 0.0, 1.0);
		1  0.2 vec4(1.0, 0.5, 0.0, 1.0);
		2  0.4 vec4(1.0, 1.0, 0.0, 1.0);
		3  0.6 vec4(0.0, 0.5, 0.0, 1.0);
		4  0.8 vec4(0.0, 0.0, 1.0, 1.0);
		5  1.0 vec4(0.5, 0.0, 0.5, 1.0);
	*/
	
	float r = float(level <= 2.0) + float(level > 4.0) * 0.5;
	float g = max(1.0 - abs(level - 2.0) * 0.5, 0.0);
	float b = (1.0 - (level - 4.0) * 0.5) * float(level >= 4.0);
	return vec4(r, g, b, 1.0);
}

float rand(vec2 co){
    return fract(sin(dot(co, vec2(12.9898, 78.233))) * 43758.5453);
}

`;

        let sdfs = Object.keys(functions).filter(x => x.startsWith("sdf"));
        let generated = Object.keys(functions).filter(x => x.includes("generated"));
        let scenes = Object.keys(functions).filter(x => x.startsWith("scene"));
        let notSDFs = Object.keys(functions).filter(x => !x.startsWith("sdf") && !x.startsWith("scene") && !x.includes("generated"));
        let _functions = {};
        generated.forEach(s => _functions[s] = functions[s]);
        sdfs.forEach(s => _functions[s] = functions[s]);
        scenes.forEach(s => _functions[s] = functions[s]);
        notSDFs.forEach(s => _functions[s] = functions[s]);
        functions = _functions;
        for (let functionName in functions) {
            shader += generateFunction(functionName, functions[functionName]) + '\n';
        }
        
        shader += `
void main() {
`;

        if (variables) {
            for (let name in variables) {
                let {type, code} = variables[name];
                shader += type + " " + name + " = " + code + ";\n";
            }
        }
        
 shader +=       `
${code}
}
`;

        cachedCode = code;
        cachedShader = shader;

        return shader;
    };
};

doc(
    "mouseSDF",
    {
        coord:'',
        position:'',
        size:'',
        cornerRadius:'',
        resolution: '',
    },
    "Calculates SDF for a given mouse coord",
    () => 1,
    {
        inlets: 5
    });
export const mouseSDF = (object, off, b, r, resolution) => {
    return ([coord]) => {
        let _off = off();
        let _b = b(); // size
        let _r = r() || 0; // corner
        let _resolution = resolution(); // corner

        if (!_b || !_resolution || !_off || !coord) {
            return undefined;
        }

        let p = [(2*coord[0] - _resolution[0])/_resolution[1],
                 (2*coord[1] - _resolution[1])/_resolution[1]];
        p = [p[0] - _off[0], p[1] - _off[1]];
        let q = [Math.abs(p[0])-_b[0]+_r,
                 Math.abs(p[1])-_b[1]+_r];

        return Math.min(Math.max(q[0], q[1]), 0) +
            Math.sqrt(
                Math.pow(Math.max(0, q[0]), 2) +
                    Math.pow(Math.max(0, q[1]), 2)) -
            _r;
    };
};


const diff = (a,b) => {
    if (!a || !b) {
        return "full";
    }
    let different = '';
    let counter=0;
    for (let i=0; i < a.length;i++) {
        if (a[i] !== b[i] && counter++ < 10) {
            different += a[i];
        }
    }
    return different;
};

const generateFunction = (functionName, {body, args, returnType}) => {
    let str = returnType + " " + functionName + "(" +
        Object.keys(args).map(argName => args[argName] + ' ' + argName).join(',') +
        ") {\n";

    str += body + '\n}';
    return str;
};
